/**
 * Единый формат ошибок API (ТЗ §7.3): { code, message, details? }.
 * Код стабилен и используется клиентом для логики, а не для показа текста.
 */
export class ApiError extends Error {
  readonly code: string;
  readonly status: number;
  readonly details?: Record<string, unknown>;

  constructor(code: string, message: string, status: number, details?: Record<string, unknown>) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.status = status;
    this.details = details;
  }
}

export const NETWORK_ERROR_CODE = 'network_error';

export function isNetworkError(error: unknown): boolean {
  if (error instanceof ApiError) {
    return error.code === NETWORK_ERROR_CODE;
  }
  return error instanceof TypeError;
}

export function errorMessage(error: unknown, fallback: string): string {
  // ТЗ §7.3: сообщение сервера не предназначено для показа — пользователю отдаётся
  // текст из файла перевода, а код ошибки используется только для логики.
  if (error instanceof ApiError) {
    return fallback;
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
}
